/**
 * 
 * @file integration portal container
 * @author Box
 */

import * as React from 'react';
import IntegrationPortal from './IntegrationPortal';
import messages from '../messages';
import ErrorMask from 'box-react-ui/lib/components/error-mask/ErrorMask';
import LoadingIndicator from 'box-react-ui/lib/components/loading-indicator/LoadingIndicator';
import { FormattedMessage } from 'react-intl';

var IntegrationPortalContainer = function IntegrationPortalContainer(_ref) {
    var hasError = _ref.hasError,
        integrationWindow = _ref.integrationWindow;

    return React.createElement(
        IntegrationPortal,
        { integrationWindow: integrationWindow },
        React.createElement(
            'div',
            { className: 'be bcow bcow-portal-container' },
            hasError ? React.createElement(ErrorMask, {
                errorHeader: React.createElement(FormattedMessage, messages.executeIntegrationOpenWithErrorHeader),
                errorSubHeader: React.createElement(FormattedMessage, messages.executeIntegrationOpenWithErrorSubHeader)
            }) : React.createElement(LoadingIndicator, {
                className: 'bcow-portal-loading-indicator',
                size: 'large'
            })
        )
    );
};

export default IntegrationPortalContainer;